export default __webpack_public_path__ + "static/media/groupon.f2f8d989.png";